import { ZusatzoptionItem } from '@ps20-frontend/frontend-models';

export enum ZusatzoptionenNameVWGEnum {
  ELEMENTAR = 'ELEMENTAR',
}

export interface ZusatzoptionItemVWG extends ZusatzoptionItem {
  name: ZusatzoptionenNameVWGEnum | string;
}
